import { PrivacyPolicy } from "@project-mgmt/ui";

export function PrivacyPage() {
  return <PrivacyPolicy />;
}
